var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTikTok = function SvgTikTok(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5903_744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 0H4C1.8 0 0 1.8 0 4V40C0 42.2 1.8 44 4 44H40C42.2 44 44 42.2 44 40V4C44 1.8 42.2 0 40 0ZM36.6 19C36.6 19 34.6 18.9 33.1 18.5C31 17.9 29.6 17.1 29.6 17.1C29.6 17.1 28.7 16.5 28.6 16.4V28.3C28.6 29 28.4 30.6 27.9 32C27.4 33.2 26.8 34.3 26 35.2C26 35.2 24.7 36.8 22.4 37.9C20.4 38.9 18.5 38.8 18 38.9C18 38.9 14.9 39 12.1 37.1C11.2 36.4 10.3 35.6 9.6 34.7C8.7 33.6 8.2 32.2 8 31.8C7.8 31.1 7.3 29.5 7.4 28C7.5 25.2 8.4 23.6 8.7 23.1C9.3 21.9 10.2 20.9 11.2 20C13.5 18.1 16.5 17.2 19.5 17.6V23.5C19 23.3 18.5 23.3 18 23.3C15.3 23.3 13.1 25.5 13.1 28.2C13.1 30.9 15.3 33.1 18 33.1C18.8 33.1 19.7 32.9 20.4 32.5C21.8 31.7 22.7 30.2 22.9 28.6V28.5C22.9 28.2 22.9 27.9 22.9 27.6V5.1H28.7C28.7 5.1 28.6 5.7 28.8 6.5C29 7.5 29.4 9 30.7 10.5C31.2 11 31.8 11.5 32.4 11.9C32.6 12 32.8 12.2 33.1 12.3C34.6 13 36 13.3 36.7 13.2V19H36.6Z",
    fill: "#266BEE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5903_744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 5,
    fill: "white"
  })))));
};
export default SvgTikTok;